import React from 'react'
import { useParams } from "react-router-dom";
import LecturePage from '../components/Lecture';

const Lecture = () => {
    const { lectureId } = useParams()
    return (<LecturePage lectureId={lectureId} />)
}

export default Lecture